// Заглушка, чтобы не ломать пользователям сборку.
import { declMod } from '@yandex-lego/i-bem-react';

export default declMod({ type: 'radio' }, { block: 'select2' });